export default __webpack_public_path__ + "static/media/3688.4767e5fb.png";